export default {
  getters: {
    categoryDescr: (state, getters, rootState) => cat => {
      let descr = "";
      if (cat != null) {
        descr = cat.descr;

        if (rootState.languageSelected != null) {
          let lang = rootState.languageSelected;
          if (lang.descrIndex == 1 && cat.descr1 != "") descr = cat.descr1;
          else if (lang.descrIndex == 2 && cat.descr2 != "") descr = cat.descr2;
        }
      }
      return descr;
    },

    itemDescr: (state, getters, rootState) => item => {
      let descr = "";
      if (item != null) {
        descr = item.descr;

        if (rootState.languageSelected != null) {
          let lang = rootState.languageSelected;
          if (lang.descrIndex == 1 && item.descr1 != "") descr = item.descr1;
          else if (lang.descrIndex == 2 && item.descr2 != "") descr = item.descr2;
        }
      }
      return descr;
    },

    categoryPosition: (state, getters, rootState) => {
      let position = "top";
      if (rootState.store != null && rootState.store.config != null && rootState.store.config.categoryPosition != null)
        position = rootState.store.config.categoryPosition;

      return position;
    },

    mainMenuEnabled: (state, getters, rootState) => {
      let enabled = false;
      if (rootState.store != null && rootState.store.config != null && rootState.store.config.mainMenuEnabled != null)
        enabled = rootState.store.config.mainMenuEnabled && getters.categoryPosition != "center";
      return enabled;
    },

    suggestedItems: (state, getters, rootState) => {
      let items;
      if (rootState.menu != null && rootState.menu.length > 0) {
        let favCat = rootState.menu.find(cat => cat.ID == -1);
        if (favCat != null)
          items = favCat.items.filter(item => item.menuTypes.includes(rootState.order.orderType) && !item.bItem && !item.disabled && !item.orderDisabled && !item.soldout);

        if (items != null && items.length > 0 && rootState.order.orderItems.length > 0) {
          let orderedItemIDs = rootState.order.orderItems.map(y => y.ID);
          items = items.filter(item => !orderedItemIDs.includes(item.ID));
        }
      }

      if (items == null) items = [];
      else if (items.length > 10) items = items.slice(0, 10);

      //console.log("suggestedItems", items);
      return items;
    },
  },
};
